import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NetworkEcoPageComponent } from './components/network-eco-page/network-eco-page.component';
import { AdminNetworkEcoComponent } from './components/admin-network-eco/admin-network-eco.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  { path: ':name', component: NetworkEcoPageComponent, data: { title: '' } },
  { path: '',canActivate:[AdminGuard],  component: AdminNetworkEcoComponent, data: { title: '' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NetworkEcosystemRoutingModule { }
